module.exports = __webpack_public_path__ + "static/media/image_37.63319c5c.png";